/*
Poornima 09/19/2022 2701012930 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Suresh Peddavoora  10/26/2022 2701127043 Removed classname for search rule group textfield .
saikrishna 11/04/2022 2701127043 Added props
Sohel 11/08/2022 2701127043 prepopulate formula code
Ashraf 11/19/2022 2701127043 resetting formula redux state.
Ashraf 11/21/2022 2701127043 fetching category lookup data.
Akhila 11/21/2022 2701127043 addAccount props pass
Sohel 11/21/2022 2701127043 props pass
Sohel 11/22/2022 2701127043 fixed page break issue
Prakash 11/22/2022 2701127043 Added conditional card spacing.
Sohel  04/25/2023 2701127043 Added Data Calculation Field

*/
import React, {useEffect} from 'react';
import SearchRuleGroupContainer from './SearchRuleGroupContainer';
import {useDispatch} from 'react-redux';
import {getBaseCategory} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {ResetRuleGroupData as resetRuleGroupData} from '../../../../../redux/reducers/BRE/AddRuleGroup';

function SearchRuleGroup({
  setValue,
  card,
  setFieldRowData,
  setBreCode,
  setResetData,
  dataReset,
  handleClose,
  setUsageState,
  usageState,
  setRowSelected,
  addAccount,
  setOpenFormulaCode,
  setSelectedFormulaCode,
  addAction,
  fieldRowData,
  setEditExisting,
  isReports,
  mapFields,
  setTempSelectedRows,
  tempSelectedRows,
  handleDataCalculationFields = () => {},
  setReportFieldValue,
  setSelectedRows,
  reportFieldsDeleteIdsRef,
  workqueueFieldsDeletedIdsRef,
  isWorkQueue,
  selectedRows,
  isReportsFilter,
  rules,
  setRules,
  setInitialValues,
  filterValues,
  filterMethodRef,
  resultExpCondition,
  handleFilterClose,
  addAccountUpdate,
  selectedGlobalField,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetRuleGroupData());
    dispatch(getBaseCategory());
    setEditExisting && setEditExisting(false);
    if (!addAccount && !isReports) {
      setFieldRowData('');
    }
  }, []);

  return (
    <>
      <div className={!handleClose && !handleFilterClose ? `` : 'col-12'}>
        <SearchRuleGroupContainer
          handleClose={handleClose}
          setValue={setValue}
          setFieldRowData={setFieldRowData}
          dataReset={dataReset}
          setBreCode={setBreCode}
          setResetData={setResetData}
          setUsageState={setUsageState}
          usageState={usageState}
          setRowSelected={setRowSelected}
          addAccount={addAccount}
          card={card}
          setOpenFormulaCode={setOpenFormulaCode}
          setSelectedFormulaCode={setSelectedFormulaCode}
          addAction={addAction}
          fieldRowData={fieldRowData}
          setEditExisting={setEditExisting}
          isReports={isReports}
          mapFields={mapFields}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          handleDataCalculationFields={handleDataCalculationFields}
          setReportSelectedRows={setSelectedRows}
          reportFieldsDeleteIdsRef={reportFieldsDeleteIdsRef}
          workqueueFieldsDeletedIdsRef={workqueueFieldsDeletedIdsRef}
          isWorkQueue={isWorkQueue}
          setReportFieldValue={setReportFieldValue}
          reportSelectedRows={selectedRows}
          isReportsFilter={isReportsFilter}
          rules={rules}
          setRules={setRules}
          setInitialValues={setInitialValues}
          filterValues={filterValues}
          filterMethodRef={filterMethodRef}
          resultExpCondition={resultExpCondition}
          handleFilterClose={handleFilterClose}
          addAccountUpdate={addAccountUpdate}
          selectedGlobalField={selectedGlobalField}
        />
      </div>
    </>
  );
}

export default SearchRuleGroup;
